const base_url = "https://eighty1handymanbe.azurewebsites.net"
//this is the link for the Production API
// const base_url = "http://localhost:8080"
export default base_url